export default function() {
  return {
    test: () => console.log("haha")
  };
}
